import { attachListener, getHomeUrl, sanitizeAndEncodeQuery } from "./utilities";

export default function main() {
    const menuDropdownItems = document.querySelectorAll('.mainNavJs .menu-item-has-children');
    for (let i = 0; i < menuDropdownItems.length; i++) {
        menuDropdownItems[i].addEventListener('click', function (e) {
            const suggsContainer = document.querySelector('.search__suggs_box');

            if (suggsContainer) {
                suggsContainer.classList.remove('active');
                suggsContainer.setAttribute('aria-hidden', 'true');
            }

            e.stopPropagation();

            // Do  nothing if inside sub-menu
            const submenu = this.querySelector('.sub-menu');
            if (submenu.contains(e.target)) {
                return;
            }

            let needToAdd = false;
            if(!this.classList.contains('active')) {
                needToAdd = true;
            } else {
                this.firstElementChild.setAttribute('aria-expanded', 'false');
            }

            for (let n = 0; n < menuDropdownItems.length; n++) {
                menuDropdownItems[n].classList.remove('active');
            }

            if(needToAdd) {
                this.classList.add('active');
                this.firstElementChild.setAttribute('aria-expanded', 'true');
            }
        });
    }

    document.addEventListener('click', closeActiveNavMenu);
    attachListener('.mainNav--desktop > .menu-item > a', 'keydown', topLevelDesktopKeydown);
    attachListener('.mainNav--mobile > .menu-item > a', 'keydown', topLevelMobileKeydown);
    attachListener('.mainNavJs .sub-menu a', 'keydown', submenuKeydown);
    attachListener('#mobileMenuBtn--container', 'keydown', mobileMenuBtnKeydown);
    //removeMobileMenuLinksFromTabOrder();

    // Mobile Menu
    //const homeUrl = getHomeUrl();
    //attachListener('#mobileMenuBtn--container', 'click', toggleMobileMenu);

    /*
    //redundant with coveo-search-header.js
    const searchSubmitButton = document.querySelector('.searchForm__submit');

    if (searchSubmitButton) {
        searchSubmitButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            const input = document.querySelector('.coveo-search-input-header');
            const searchValue = input ? input.value.trim() : '';
            
            if (searchValue) {
                window.location.href = `/search/?q=${encodeURIComponent(searchValue)}`;
            }
        });
    }
    */

    // Clear button functionality
    const searchForm = document.getElementById('searchForm');
    const searchInput = document.getElementById('searchForm__input');
    const clearButton = document.querySelector('.headerSearch__clear');
    
    function toggleClearButton() {
        if (searchInput.value.trim().length > 0) {
            searchForm.classList.add('searchForm--has-content');
        } else {
            searchForm.classList.remove('searchForm--has-content');
        }
    }
    
    // Check on input events
    searchInput.addEventListener('input', toggleClearButton);
    searchInput.addEventListener('keyup', toggleClearButton);
    searchInput.addEventListener('paste', function() {
        // Use setTimeout to wait for paste content to be processed
        setTimeout(toggleClearButton, 10);
    });
    
    // Clear button functionality
    clearButton.addEventListener('click', function(e) {
        e.preventDefault();
        searchInput.value = '';
        searchInput.focus();
        toggleClearButton();
    });
    
    // Initial check in case input has value on page load
    toggleClearButton();

    //sticky header on scroll 
    window.onscroll = function() {
        // Get the header
        var header = document.querySelector('.mainHeader');
        var mobileHeader = document.getElementById('mobileHeader');

        var body = document.getElementsByTagName("body")[0];
        var sticky = 1;
        if (window.pageYOffset > sticky) {
            header.classList.add("sticky");
            body.classList.add('sticky');
        } else {
            header.classList.remove("sticky");
            body.classList.remove('sticky');
        }
    };

    //Handles clicking outside menu to close it - Might not work cross-browser
    $(document).click(function() {
        $('.mainNav ul li.active').removeClass('active');
    });

    // close submenu when hover off
    $('.sub-menu').on({
        mouseleave: function () {
            $('.mainNav ul li.active').removeClass('active');
        }
    });

    // handles placeholder text for search forms (alternitive to using a placeholder)
    $(".searchForm__luis").each(function () {
    var inputVal = $(this).val();
    $(this)
        .focus(function (event) {
            if (this.value == inputVal) {
                this.value = "";
            }
        })
        .blur(function (event) {
            if (this.value == "") {
                this.value = inputVal;
            }
        });
    });
}

function mobileMenuBtnKeydown(event) {
    if (event.code === 'Enter'
    || event.code === 'Space') {
        event.preventDefault();
        event.target.click();
        const firstMenuLink = document.querySelector('.mainNav--mobile > li:first-of-type > a');
        firstMenuLink.focus();
    }
}

/* not sure if this is needed, commenting out for now
function removeMobileMenuLinksFromTabOrder() {
    const links = document.querySelectorAll('.mobileMenu a not(.actionBar__link)');
    for (let link of links) {
        link.setAttribute('tabindex', '-1');
    }
}
*/

function closeActiveNavMenu() {
    const activeNavs = document.querySelectorAll('.mainNavJs .active');
    for (let active of activeNavs) {
        active.classList.remove('active');
    }
}

function topLevelDesktopKeydown(event) {
    if (event.code === 'Tab') {
        if (event.shiftKey) {
            const prevItem = event.target.parentElement.previousElementSibling;
            if (prevItem) {
                event.preventDefault();
                prevItem.firstElementChild.focus();
            }
        } else {
            const nextItem = event.target.parentElement.nextElementSibling;
            if (nextItem) {
                event.preventDefault();
                nextItem.firstElementChild.focus();
            }
        }
    } else if (event.code === 'ArrowLeft') {
        event.preventDefault();
        focusPrevMenuItem(event.target);
    } else if (event.code === 'ArrowRight') {
        event.preventDefault();
        focusNextMenuItem(event.target);
    }  else if (event.code === 'Home') {
        event.preventDefault();
        focusFirstMenuItem(event.target);
    } else if (event.code === 'End') {
        event.preventDefault();
        focusLastMenuItem(event.target);
    } else if (event.code === 'ArrowDown'
    || event.code === 'Space'
    || event.code === 'Enter') {
        event.preventDefault();
        const submenu = event.target.nextElementSibling;
        if (submenu) {
            event.target.parentElement.click();
            event.target.nextElementSibling.firstElementChild.firstElementChild.focus();
        } else {
            event.target.click();
        }
    }
}

function topLevelMobileKeydown(event) {
    if (event.code === 'Tab') {
        if (event.shiftKey) {
            event.preventDefault();
            const prevItem = event.target.parentElement.previousElementSibling;
            if (prevItem) {
                prevItem.firstElementChild.focus();
            } else if (!prevItem || prevItem.parentElement.parentElement.parentElement.parentElement.previousElementSibling.id == 'mobileMenu__actionBar') {
                const lastActionBarItem = document.getElementById('mobileMenu__actionBar').lastElementChild.lastElementChild.lastElementChild;
                lastActionBarItem.focus();
            } else {
                //closeMobileMenu();
                const mobileMenuBtn = document.querySelector('#mobileMenuBtn--container');
                mobileMenuBtn.focus();
            }
        } else {
            const nextItem = event.target.parentElement.nextElementSibling;
            if (nextItem) {
                event.preventDefault();
                nextItem.firstElementChild.focus();
            } else {
                // using a timer or else focus gets set on next focuasable element.
                window.setTimeout(() => document.getElementById('mobileHeader').firstElementChild.focus(), 0);
            }
        }
    } else if (event.code === 'ArrowUp') {
        event.preventDefault();
        focusPrevMenuItem(event.target);
    } else if (event.code === 'ArrowDown') {
        event.preventDefault();
        focusNextMenuItem(event.target);
    }  else if (event.code === 'Home') {
        event.preventDefault();
        focusFirstMenuItem(event.target);
    } else if (event.code === 'End') {
        event.preventDefault();
        focusLastMenuItem(event.target);
    } else if (event.code === 'Space'
    || event.code === 'Enter') {
        event.preventDefault();
        const submenu = event.target.nextElementSibling;
        if (submenu) {
            event.target.parentElement.click();
            event.target.nextElementSibling.firstElementChild.firstElementChild.focus();
        } else {
            event.target.click();
        }

    } else if (event.code === 'Escape') {
        closeMobileMenu();
        const mobileMenuBtn = document.querySelector('#mobileMenuBtn--container');
        mobileMenuBtn.focus();
    }
}

function focusFirstMenuItem(targetLink) {
    const link = targetLink.parentElement.parentElement.firstElementChild.firstElementChild;
    link.focus();
}

function focusLastMenuItem(targetLink) {
    const link = targetLink.parentElement.parentElement.lastElementChild.firstElementChild;
    link.focus();
}

function focusNextMenuItem(targetLink) {
    const nextItem = targetLink.parentElement.nextElementSibling;
    if (nextItem) {
        nextItem.firstElementChild.focus();
    }
}

function focusPrevMenuItem(targetLink) {
    const prevItem = targetLink.parentElement.previousElementSibling;
    if (prevItem) {
        prevItem.firstElementChild.focus();
    }
}

function mobileMenuTabClick (event) {
    var mainMenuId = 'mobileMenu__mainMenu';
    var tabContentId = event.target.getAttribute('aria-controls');
    document.getElementById(mainMenuId).classList.add('mainMenu--hidden');
    mobileMenuTabindex(mainMenuId, '-1');
    document.getElementById(tabContentId).classList.add('tabContent--active');
    mobileMenuTabindex(tabContentId, '0');
    document.getElementById('mobileMenu').scroll({top: 0, behavior: 'instant'});
}

function mobileMenuBack(event) {
    var mainMenuId = 'mobileMenu__mainMenu';
    var tabContent = event.target.parentElement;
    tabContent.classList.remove('tabContent--active');
    mobileMenuTabindex(tabContent.id, '-1');
    document.getElementById(mainMenuId).classList.remove('mainMenu--hidden');
    mobileMenuTabindex(mainMenuId, '0');
    document.getElementById('mobileMenu__tabBar').firstElementChild.firstElementChild
        .firstElementChild.firstElementChild.focus();
}

function submenuKeydown(event) {
    if (event.code === 'Tab') {
        if (event.shiftKey) {
            event.preventDefault();
            const prevItem = event.target.parentElement.previousElementSibling;
            if (prevItem) {
                prevItem.firstElementChild.focus();
            } else {
                const parentListItem = event.target.closest('.menu-item-has-children');
                parentListItem.firstElementChild.focus();
                closeTopLevelItem(parentListItem);
            }
        } else {
            const nextItem = event.target.parentElement.nextElementSibling;
            if (nextItem) {
                event.preventDefault();
                nextItem.firstElementChild.focus();
            } else {
                const parentListItem = event.target.closest('.menu-item-has-children');
                const nextParentListItem = parentListItem.nextElementSibling;
                if (nextParentListItem) {
                    event.preventDefault();
                    nextParentListItem.firstElementChild.focus();
                }
                // Otherwise it will go to default next item in tab order out of menu.
                closeTopLevelItem(parentListItem);
            }
        }
    } else if (event.code === 'ArrowDown') {
        event.preventDefault();
        focusNextMenuItem(event.target);
    } else if (event.code === 'ArrowUp') {
        event.preventDefault();
        focusPrevMenuItem(event.target);
    } else if (event.code === 'Home') {
        event.preventDefault();
        focusFirstMenuItem(event.target);
    } else if (event.code === 'End') {
        event.preventDefault();
        focusLastMenuItem(event.target);
    } else if (event.code === 'Escape') {
        // close submenu focus parent
        const parentListItem = event.target.closest('.menu-item-has-children');
        parentListItem.firstElementChild.focus();
        closeTopLevelItem(parentListItem);
    } else if (event.code === 'Space'
    || event.code === 'Enter') {
        event.preventDefault();
        event.target.click();
    }
}

function closeTopLevelItem(item) {
    item.classList.remove('active');
    item.firstElementChild.setAttribute('aria-expanded', 'false');
}

function toggleMobileMenu() {
    const btnContainer = document.getElementById('mobileMenuBtn--container');
    const mobileMenu = document.getElementById('mobileMenu');
    if (!btnContainer || !mobileMenu) {
        return;
    }

    if (mobileMenu.classList.contains('mobileMenu--active')) {
        document.body.classList.remove('noscroll');
        mobileMenu.classList.remove('mobileMenu--active');
        btnContainer.setAttribute('aria-expanded', 'false');
    } else {
        btnContainer.setAttribute('aria-expanded', 'true');
    }
    btnContainer.classList.toggle('active');
    mobileMenu.classList.toggle('active');
    document.body.classList.toggle('noscroll');
}

function closeMobileMenu() {
    const btnContainer = document.getElementById('mobileMenuBtn--container');
    const mobileMenu = document.getElementById('mobileMenu');
    if (!btnContainer || !mobileMenu) {
        return;
    } else {
        document.body.classList.remove('noscroll');
        mobileMenu.classList.remove('active');
        btnContainer.classList.remove('active');
        btnContainer.setAttribute('aria-expanded', 'false');
    }
}

function mobileMenuCloseClickOutside(event) {
    if (!document.getElementById('mobileMenu').contains(event.target)
        && !document.getElementById('mobileHeader').contains(event.target)) {
        toggleMobileMenu();
    }
}